// extracted by mini-css-extract-plugin
export default {"btn":"Buton_btn__X2WE4","btn_text":"Buton_btn_text__cby9g"};